var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { useCookies } from "react-cookie";
import { checkIdentity, checkInitialPrinting, checkManaValue, checkPowerToughnessSum, checkSubTypes } from '../../services/gameLogic.service';
import { CookieKeys } from "../../constants/cookies";
import SetSymbol from "../SetSymbol";
import styles from '../../styles/Cell.module.scss';
var MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
var Cell = function (_a) {
    var col = _a.col, guessCard = _a.guessCard, answerCard = _a.answerCard;
    var _b = useState('empty'), delayedStyleProp = _b[0], setDelayedStyleProp = _b[1];
    var cookies = useCookies([CookieKeys.colorblindAssist])[0];
    var useColorAssist = cookies[CookieKeys.colorblindAssist] === 'true';
    var styleProps = 'empty';
    var value = '';
    if (guessCard && answerCard) {
        styleProps = 'gray';
        // Color Check
        if (col === 0) {
            styleProps = checkIdentity(answerCard, guessCard);
            value = (_jsx("div", __assign({ className: styles.colorIconContainer }, { children: guessCard.color_identity.map(function (color) { return _jsx("i", { className: "ms ms-cost ms-".concat(color.toLowerCase()) }, color); }) }), void 0));
        }
        // Mana Check
        else if (col === 1) {
            styleProps = checkManaValue(answerCard, guessCard);
            value = guessCard.cmc;
        }
        // Set Check
        else if (col === 2) {
            styleProps = checkInitialPrinting(answerCard, guessCard);
            var year = guessCard.released_at.split('-')[0];
            var month = MONTHS[Number(guessCard.released_at.split('-')[1]) - 1];
            value = (_jsxs("span", __assign({ className: styles.editionContainer }, { children: [_jsx(SetSymbol, { set: guessCard.set, rarity: guessCard.rarity }, void 0), " ", month, _jsx("br", {}, void 0), year] }), void 0));
        }
        // Power Check
        else if (col === 3) {
            var guessPower = Number(guessCard.card_faces ? guessCard.card_faces[0].power : guessCard.power) || 0;
            var guessToughness = Number(guessCard.card_faces ? guessCard.card_faces[0].toughness : guessCard.toughness) || 0;
            styleProps = checkPowerToughnessSum(answerCard, guessCard);
            value = guessPower + guessToughness;
        }
        // Subtypes Check
        else if (col === 4) {
            var guessSubtypes = guessCard.type_line.split('—')[1].trim().split(' ');
            styleProps = checkSubTypes(answerCard, guessCard);
            value = guessSubtypes.join(', ');
        }
    }
    useEffect(function () {
        if (styleProps === 'empty')
            setDelayedStyleProp(styleProps);
        else
            setTimeout(function () { return setDelayedStyleProp(styleProps); }, col * 500);
    }, [styleProps, col]);
    return (_jsx("div", __assign({ className: styleProps === 'up' || styleProps === 'down' ? "".concat(styles.cellOuter, " ").concat(styles.blue) : styles.cellOuter }, { children: _jsxs("div", __assign({ className: styles.cellInner, style: delayedStyleProp !== 'empty' ? { transform: 'rotateY(180deg)' } : {} }, { children: [_jsx("div", { className: styles.cell }, void 0), _jsx("div", __assign({ className: "".concat(styles[delayedStyleProp], " ").concat(useColorAssist ? styles.colorAssist : '') }, { children: delayedStyleProp !== 'empty' && value }), void 0)] }), void 0) }), void 0));
};
export default Cell;
